module.exports = __webpack_public_path__ + "static/media/211CS220.9e1db736.jpg";